import React from 'react';

interface TitleSkeletonProps {
  className?: string;
}

const TitleSkeleton: React.FC<TitleSkeletonProps> = ({ className = '' }) => {
  return (
    <div className={`animate-pulse ${className}`}>
      <div className="h-6 bg-gray-200 rounded-md w-32 mx-auto"></div>
    </div>
  );
};

export default TitleSkeleton;